
<po-page-list #poPageListComponent
  p-title="Relatório de Lotes Vs Estoque"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <div class="po-row">
    <po-button class="po-md-2 po-mb-2" p-kind="secondary" p-label="Excel" (p-click)="gerarExcel()" > </po-button>
  </div>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
    [p-sort]="false"
  ></po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker
      class="po-md-6"
      name="DZ00DATA_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de :">
    </po-datepicker>

    <po-datepicker
      class="po-md-6"
      name="DZ00DATA_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até :">
    </po-datepicker>
    <po-input
      class="po-md-6"
      name="CZ02LOTE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ02LOTE"
      p-label="Lote"
    ></po-input>
    <po-select
      class="po-md-6"
      name="CTIPO"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CTIPO"
      p-label="Status"
      [p-options]="[
            { label: 'Faturado e Não Embarcado', value: 'E' },
            { label: 'Faturado Embarcado', value: 'C' }
        ]"
    ></po-select>
    <po-lookup class="po-md-6"
      name="CA1CODLOJA"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CA1CODLOJA"
      p-field-label="CA1NREDUZ"
      p-field-value="CA1CODLOJA"
      p-label="Cliente"
      [p-columns]="columnsClienteFilters"
      [p-field-format]="fieldFormaterClienteFilters"
      [p-filter-service]="clienteLookupService"
      [p-advanced-filters]="advancedClienteFilters"
      [p-literals]="{ modalTitle: 'Cliente' }"
      (p-selected)="clienteSelecionado($event)"
    ></po-lookup>
    <po-input
      class="po-md-6"
      name="CZ00COD"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00COD"
      p-label="Romaneio"
    ></po-input>
    <po-lookup class="po-sm-12 po-md-12 po-lg-12"
        p-label="Produto"
        name="CB1COD"
        [(ngModel)]="tabelaPrincipalFiltro.dados.CB1COD"
        p-field-value="CB1COD"
        p-field-label="CB1DESC"
        [p-columns]="columnsProdutoFilters"
        [p-field-format]="produtoLookupService.getFieldFormater"
        [p-filter-service]="produtoLookupService"
        [p-advanced-filters]="produtoLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Produto' }"
        [p-filter-params]="{CB1MSBLQL: '2'}"
      ></po-lookup>
  </form>
</po-modal>
